import { DeploymentDetailsDeviceDto } from 'dto/deployment/deployment-details.dto';
import { IDeviceInfo } from 'dto/device-dto';

export interface IDeploymentReportDeviceContext {
    deviceGroupLabel: string;
    units: string;
}

export class DeploymentReportDeviceViewModel implements IDeviceInfo {
    readonly UID: string;
    readonly serialNumber: string;
    readonly esn: string;
    readonly deviceGroupLabel: string;
    readonly lastUpdatedDateTime: Date;
    readonly lastUpdated: number;
    readonly trampolineVersion: string;
    readonly firmwareVersion: string;
    readonly units: string;
    readonly executionStatus: string;

    constructor(device: DeploymentDetailsDeviceDto, context: IDeploymentReportDeviceContext) {
        this.UID = device.deviceName;
        this.serialNumber = device.serialNumber;
        this.esn = device.esn;
        this.deviceGroupLabel = context.deviceGroupLabel;
        this.lastUpdatedDateTime = device.lastJobSuccessAt;
        this.lastUpdated = device.lastJobSuccessAt?.getTime();
        this.trampolineVersion = device.trampolineVersion;
        this.firmwareVersion = device.firmwareVersion;
        this.units = context.units;
        this.executionStatus = device.executionStatus;
    }
}

export const buildDeploymentReportDeviceViewModel = (
    device: DeploymentDetailsDeviceDto,
    context: IDeploymentReportDeviceContext,
): DeploymentReportDeviceViewModel => new DeploymentReportDeviceViewModel(device, context);
